import React, { useEffect, useState } from 'react';
import { Table, Popconfirm, Button, Modal, Input, message } from "antd";
import Delete from "../../../../assets/images/delete_icon.svg";
import Edit from "../../../../assets/images/edit_icon.svg";

import { PlusCircleFilled } from '@ant-design/icons';
import MenuSetting from '../../../../services/menuSetting';


const Courses = (props) => {

    const [courseList, setCourseList] = useState([]);
    const [name, setName] = useState("");
    const [time, setTime] = useState(null);
    const [showAdd, setShowAdd] = useState(false);
    const [editClicked, setEditClicked] = useState(false);
    const [editRecord, setEditRecord] = useState();
    const [loading, setLoading] = useState(true);


    const getCourse = () => {
        MenuSetting.getMenuCourse(props.adminRestaurant).then((resp)=>{
          setCourseList(resp);
          setLoading(false);
        });
      };
      const saveCourse = () => {
        if(name && time) {
            if(editClicked)
            {
                MenuSetting.updateMenuCourse({
                    "name" : name,
                    "transition_time": parseInt(time),
                    "priority": 5,
                },editRecord?.id).then((resp)=>{
                    if(resp) {
                        message.success("Saved Successfully");
                        getCourse();
                        setName("");
                        setTime(null);
                        setShowAdd(false);
                    }    
                });
            }
            else
            MenuSetting.saveMenuCourse({
                "name" : name,
                "transition_time": parseInt(time),
                "priority": 5,
            }).then((resp)=>{
                if(resp) {
                    message.success("Saved Successfully");
                    getCourse();
                    setName("");
                    setTime(null);
                    setShowAdd(false);
                }    
            });
        } else {
            message.warning("Please enter course name and time");
        }
      };
      const deleteCourse = (id) =>{
        MenuSetting.deleteMenuCourse(id).then((res)=>{
            if(res){
                message.success("Deleted Successfully");
                getCourse();
            }
        });
      }
      useEffect(()=>{
        getCourse();
        // saveCourse();
      }, []);
    const columns = [
        {
            title: 'Courses',
            dataIndex: 'name',
            key: 'name',
            width: '40%' 
        },
        {
            title: 'Transition Time (minutes)',
            dataIndex: 'transition_time',
            key: 'transition_time',
            width: '45%'
        },
        {
            title: 'Action',
            width: '15%', 
            render: (_, record) => {
                return <div
                    style={{
                        display: "flex", width: '150px'}}>
                        <>
                        <img src={Edit} alt="" className="update_action" onClick={(e) => {
                                e.stopPropagation()
                                setShowAdd(true)
                                setEditClicked(true);
                                setEditRecord(record)
                                setName(record?.name)
                                setTime(record?.transition_time);
                            }} /> &nbsp;&nbsp;
                            <Popconfirm title="Sure to delete?" onConfirm={(e) => {
                                e.stopPropagation()
                                deleteCourse(record.id)
                            }
                            }>
                            <img src={Delete} alt="" className="update_action" />
                            </Popconfirm>
                        </>
                </div>
            }
        }
    ];
    return <>
        <div style={{ textAlign: 'end'}}>
            <Button type="text" icon={<PlusCircleFilled/>} danger className="addparties-btn" onClick={()=> setShowAdd(true) }>
            Add Course
            </Button>
        </div>
        <div className="table_section field_wrap">
            <Table columns={columns} bordered dataSource={courseList} className="customise-table" loading={loading} />
        </div>
        <Modal title={editClicked ? "Update Course":"Add Course"} visible={showAdd} footer={null} onCancel={()=>{setShowAdd(false);
            setEditClicked(false)
        }}>
            <div style={{marginBottom: 15 }}><Input placeholder='Enter Course name*' value={name} onChange={(e)=>{ setName(e.target.value) }} /></div>
            <div><Input placeholder='Enter Transition time* (in minutes)' value={time} type="number" onChange={(e)=>{ setTime(e.target.value.replace(/[^0-9.]/g, "")) }} /></div>
            <div className='save_course_setting'>
                <Button type='primary' onClick={()=>{saveCourse()}}>Save</Button>
            </div>
        </Modal>
    </>
};
export default Courses;
